import hydrate from '../common/hydrate';
import NewsletterSignup from './components/NewsletterSignup';
import { root, name } from './manifest.json';
hydrate(NewsletterSignup, root, name);
if (module.hot) {
    module.hot.accept();
}
